export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center pt-16">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-6 tracking-wide">
              Kakobuy Spreadsheet 2026
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight">
              Kakobuy Spreadsheet Polska
            </h1>
            <p className="text-lg md:text-xl text-foreground-500 mt-2 mb-4 font-heading italic">
              Największa Baza Produktów, Linków i Kakobuy Finds
            </p>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto lg:mx-0 leading-relaxed">
              Znajdź najlepsze produkty, porównuj ceny i korzystaj z uporządkowanych list <strong>Kakobuy Spreadsheet</strong> przygotowanych dla polskich użytkowników.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 mt-8 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                Sprawdź Kakobuy Spreadsheet
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#kategorie"
                className="w-full sm:w-auto px-8 py-3.5 bg-background-100 text-foreground-800 rounded-full text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                Zobacz najlepsze Finds
                <i className="ri-arrow-down-line ml-2"></i>
              </a>
            </div>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mt-8 text-xs text-foreground-500">
              <span className="flex items-center gap-1"><i className="ri-check-line text-accent-500"></i> Aktualizowane listy</span>
              <span className="flex items-center gap-1"><i className="ri-check-line text-accent-500"></i> Porównania kategorii</span>
              <span className="flex items-center gap-1"><i className="ri-check-line text-accent-500"></i> Bezpieczne korzystanie</span>
              <span className="flex items-center gap-1"><i className="ri-check-line text-accent-500"></i> Przewodniki</span>
            </div>
          </div>

          <div className="flex-1 w-full">
            <div className="relative w-full h-[320px] md:h-[420px] lg:h-[480px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20collage%20of%20diverse%20fashion%20products%20including%20colorful%20sneakers%20in%20coral%20pink%20white%20hoodie%20sage%20green%20sweater%20denim%20jacket%20gold%20watch%20leather%20bag%20on%20warm%20textured%20sand%20colored%20paper%20background%20soft%20diffused%20morning%20light%20creative%20editorial%20composition%20overlapping%20items%20with%20intentional%20negative%20space%20scandinavian%20aesthetic%20high%20detail%20film%20grain%20warm%20neutral%20palette&width=1200&height=960&seq=hero-main-v2&orientation=landscape"
                alt="Kakobuy Spreadsheet Polska - produktowa baza danych"
                title="Kakobuy Spreadsheet – baza produktów"
                className="w-full h-full object-cover object-top"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/20"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}